export function SectionHeader({ number, children = null }) {
  return (
    <h2 className="text-center font-bold my-4 uppercase">
      § {number}
      <br />
      {children}
    </h2>
  )
}

export function NumberList(props) {
  return <ol className="list-decimal" {...props} />
}

export function AlphaList(props) {
  return <ol className="ml-8 listStyleType-[lower-alpha]" {...props} />
}

export function DashList(props) {
  return <ul className="ml-4 listStyleType-['-']" {...props} />
}
